import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {KurzArbeitVoranmeldung} from '../../model/api/KurzArbeitVoranmeldung';
import {Costumer} from '../../model/api/Costumer';
import {CostumerService} from '../../services/costumer/costumer.service';
import {KurzArbeitVoranmeldungService} from '../../services/kurzArbeitVoranmeldung/kurz-arbeit-voranmeldung.service';
import {SessionService} from '../../services/session/session.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-gefuehrtes-form',
  templateUrl: './gefuehrtes-form.component.html',
  styleUrls: ['./gefuehrtes-form.component.scss']
})
export class GefuehrtesFormComponent implements OnInit {

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  fifthFromGroup: FormGroup;

  @Input()
  readonly: Boolean = false;

  @Output()
  abschliessenCall = new EventEmitter<KurzArbeitVoranmeldung>();

  constructor(private costumerService: CostumerService,
              private kurzArbeitVoranmeldungService: KurzArbeitVoranmeldungService,
              private session: SessionService,
              private _formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      arbeitgeber: ['', Validators.required],
      branche: ['', Validators.required],
      telefon: ['', Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      abteilungsName: ['', Validators.required],
      gueltigkeitsBereicht: ['', Validators.required],
    });
    this.thirdFormGroup = this._formBuilder.group({
      grund: ['', Validators.required],
    });
    this.fourthFormGroup = this._formBuilder.group({
      bestandInsgesamt: ['', Validators.required],
      bestandGekuendigt: ['', Validators.required],
      bestandAbruf: ['', Validators.required],
      betroffeneAnzMitarbeiter: ['', Validators.required],
    });
    this.fifthFromGroup = this._formBuilder.group({
      dauerVon: ['', Validators.required],
      dauerBis: ['', Validators.required],
      prozAusfall: ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(100)])],
      arbeitslosenkasse: ['', Validators.required],
      ausgleichskasse: ['', Validators.required],
      ortDatum: ['', Validators.required],
    });
    this.secondFormGroup.get('gueltigkeitsBereicht').valueChanges.subscribe(val => {
      if (val === 'betriebsabteilung') {
        this.secondFormGroup.controls['abteilungsName'].setValidators([Validators.required]);
        this.secondFormGroup.controls['abteilungsName'].updateValueAndValidity();
      } else {
        this.secondFormGroup.controls['abteilungsName'].clearValidators();
        this.secondFormGroup.controls['abteilungsName'].updateValueAndValidity();
      }
    });
  }

  abschliessen() {
    this.abschliessenCall.emit(this.session.kurzArbeitVoranmeldung);
  }
}
